import React, { useState } from 'react';
import { useIsAuthenticated } from "@azure/msal-react";
import { useLogin } from '../../hooks/useAuth';
import styles from './auth.module.css';

const PrivateRoute = ({ children, fallback = null }) => {
    const isAuthenticated = useIsAuthenticated();
    const { loginPopup } = useLogin();
    const [rememberMe, setRememberMe] = useState(false);

    if (!isAuthenticated) {
        if (fallback) {
            return fallback;
        }
        
        return (
            <div className={styles['private-route-container']}>
                <div className={styles['auth-required']}>
                    <h2>Login Required</h2>
                    <p>You need to sign in to access this page.</p>
                    <button 
                        className={`${styles['auth-button']} ${styles['login-button']}`}
                        onClick={() => loginPopup(rememberMe)}
                    >
                        Sign In
                    </button>
                    <label className={styles['remember-me-label']} style={{ marginTop: '1rem' }}>
                        <input 
                            type="checkbox" 
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                            className={styles['remember-me-checkbox']}
                        />
                        <span>Remember me for 7 days</span>
                    </label>
                    {rememberMe && (
                        <span className={styles['security-hint']}>
                            Don't use on shared computers
                        </span>
                    )}
                </div>
            </div>
        );
    }

    return children;
};

export default PrivateRoute;
